import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormlyModule } from '@ngx-formly/core';

import { RadioTypeComponent } from './radio-type.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormlySelectModule } from '@ngx-formly/core/select';

@NgModule({
  declarations: [RadioTypeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatFormFieldModule,
    FormlySelectModule,
    FormlyModule.forChild({
      types: [
        {
          name: 'radio',
          component: RadioTypeComponent,
        },
      ],
    }),
  ],
})
export class RadioTypeModule {}
